import { render, staticRenderFns } from "./watcher.vue?vue&type=template&id=9c6f9402&"
import script from "./watcher.component.ts?vue&type=script&lang=ts&"
export * from "./watcher.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports